import { render, staticRenderFns } from "./Comp32t3.vue?vue&type=template&id=fe4f98ca&scoped=true&"
import script from "./Comp32t3.vue?vue&type=script&lang=js&"
export * from "./Comp32t3.vue?vue&type=script&lang=js&"
import style0 from "./Comp32t3.vue?vue&type=style&index=0&id=fe4f98ca&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe4f98ca",
  null
  
)

export default component.exports